import { Users, FolderDown, Headphones, BadgeCheck } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { PublicLayout } from "@/components/PublicLayout";
import { RequestForm } from "@/components/RequestForm";
import { useAuth } from "@/context/AuthContext";

const PERKS = [
  [Users, "Tutti i tuoi clienti in un pannello", "Gestisci le aziende che segui: fatture emesse e ricevute, corrispettivi e documenti sempre aggiornati."],
  [FolderDown, "Archivio XML pronto per la contabilit\u00e0", "Scarichi gli XML dei clienti per periodo in un unico file ZIP, senza chiederli ogni mese."],
  [BadgeCheck, "Condizioni riservate ai partner", "Per gli studi che portano i propri clienti sulla piattaforma prevediamo condizioni dedicate: le concordiamo insieme.", true],
  [Headphones, "Supporto diretto", "Un contatto dedicato per te e per le aziende che ci presenti."],
];

export default function Partner() {
  useSeo("Diventa partner: commercialisti", "Programma partner per studi commercialisti: gestisci i clienti, scarica gli XML e ottieni condizioni dedicate con FatturazioneGestionale.", "/partner");
  const { user } = useAuth();
  const perks = PERKS.filter((p) => !p[3] || user?.role === "studio");
  return (
    <PublicLayout testid="partner-page">
      <div className="max-w-3xl">
        <div className="font-mono text-xs uppercase tracking-[0.25em] text-sky-700">Programma partner</div>
        <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">Sei un commercialista? Diventa partner</h1>
        <p className="mt-4 text-base text-slate-600">Porta i tuoi clienti su FatturazioneGestionale: loro fatturano e gestiscono il magazzino, tu ricevi i documenti già pronti per la contabilità.</p>
      </div>
      <div className={`mt-12 grid gap-5 sm:grid-cols-2 ${perks.length === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}>
        {perks.map(([I, t, d]) => (
          <div key={t} data-testid={`partner-perk-${PERKS.findIndex((p) => p[1] === t)}`} className="rounded-xl border border-slate-200 bg-white p-6">
            <I className="h-6 w-6 text-sky-600" />
            <h2 className="mt-4 text-base font-bold text-slate-900">{t}</h2>
            <p className="mt-2 text-sm text-slate-600">{d}</p>
          </div>
        ))}
      </div>
      <div className="mt-16 grid gap-10 lg:grid-cols-[1fr_1.4fr]">
        <div>
          <h2 className="font-display text-2xl font-extrabold text-slate-900">Richiedi di diventare partner</h2>
          <p className="mt-3 text-sm text-slate-600">Lascia i dati dello studio: ti ricontattiamo per spiegarti il programma e attivare il tuo pannello.</p>
        </div>
        <RequestForm tipo="partner" />
      </div>
    </PublicLayout>
  );
}
